'use strict';

class OverviewList {
  constructor($routeParams, $location, $filter, overviewService, I18N, Notification, invoiceService) {
    this.$routeParams = $routeParams;
    this.$location = $location;
    this.$filter = $filter;
    this.overviewService = overviewService;
    this.invoiceService = invoiceService;
    this.I18N = I18N;
    this.Notification = Notification;
  }

  $onInit() {
    this.loading = false;
    this.allSelected = false;
    this.selectedInvoiceNos = [];

    this.year = this.$routeParams.year;
    this.state = this.$location.search().state;
    this.type = this.$location.search().type;

    this.documents = [];
    this.total = 0;
    this.taxTotal = 0;
    this.title = 'Oversikt';

    if (this.state && this.state in this.I18N.overview.categories) {
      this.title = this.I18N.overview.categories[this.state];
    }

    // sorting
    this.predicate = 'number';
    this.reverse = true;

    this.load(this.year);
  }

  deleteDrafts() {
    swal({
      title: 'Er du sikker?',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        swal.close();
        this.loading = true;

        //remove duplicates
        let unique = this.selectedInvoiceNos.filter((a, b) => this.selectedInvoiceNos.indexOf(a) === b);

        if (unique.length) {
          this.invoiceService.massDeleteDrafts({
            invoiceNos: unique
          })
            .then((resp) => {
              this.loading = false;
              this.selectedInvoiceNos = [];
              this.allSelected = false;

              this.load(this.year);
              this.Notification.success('Kladder slettet');
            })
            .catch(() => {
              this.loading = false;
              this.Notification.error('Sletting mislyktes');
            });
        } else {
          this.loading = false;
          this.Notification.error('Du må velge minst en faktura');
        }
      }
    });
  }

  isSelected(invoiceNumber) {
    return this.selectedInvoiceNos.indexOf(invoiceNumber) !== -1;
  }

  selectHandler(invoiceNumber) {
    var index = this.selectedInvoiceNos.indexOf(invoiceNumber);

    if (index !== -1) {
      this.selectedInvoiceNos.splice(index, 1);
    } else {
      this.selectedInvoiceNos.push(invoiceNumber);
    }
  }
  toggleSelection() {
    if (this.allSelected) {
      this.documents.forEach((item) => {
        if (!this.isSelected(item.number)) {
          this.selectedInvoiceNos.push(item.number);
        }
      });
    } else {
      this.documents.forEach((item) => {
        var index = this.selectedInvoiceNos.indexOf(item.number);
        if (index !== -1) {
          this.selectedInvoiceNos.splice(index, 1);
        }
      });
    }
  }

  order(predicate) {
    this.reverse = this.predicate === predicate ? !this.reverse : false;
    this.predicate = predicate;
  }

  load(filter) {
    // if (this.state && this.type) {
      this.overviewService.list(this.state, this.type, filter)
        .then((resp) => {
          if (resp.data && resp.status !== 204) {
            let total = 0;
            let taxTotal = 0;

            resp.data.forEach((item) => {
              if (this.$filter('urlParser')(item._links.self.uri, 1) === 'drafts') {
                item.isDraft = true;
              }

              total += item.total;
              taxTotal += item.tax;

              return item;
            }, this);

            this.total = total;
            this.taxTotal = taxTotal;

            this.documents = resp.data;
          } else {
            this.documents = [];
          }
        });
    // }
  }
}

OverviewList.$inject = ['$routeParams', '$location', '$filter', 'overviewService', 'I18N', 'Notification', 'invoiceService'];

const overviewList = {
  controller: OverviewList,
  template: `
    <h2>{{ $ctrl.title }}<span ng-hide="$ctrl.year == 'null'"> - {{ $ctrl.year }}</span> <small>({{ $ctrl.documents.length }} stk)</small></h2>
    <p>Trykk p&aring; fakturanummeret for &aring; redigere regningen, trykk p&aring; mottager for &aring; redigere mottageren.</p>

    <table class="responsive" ng-show="$ctrl.documents && $ctrl.documents.length > 0">
      <thead>
        <tr>
          <th ng-show="$ctrl.state === 'draft'">
            <input type="checkbox" ng-model="$ctrl.allSelected" ng-click="$ctrl.toggleSelection($event)" />
          </th>
          <th></th>
          <th ng-click="$ctrl.order('number')" ng-class="{ sortorder: $ctrl.predicate == 'number', reverse: $ctrl.reverse }">#</th>
          <th ng-click="$ctrl.order('description')" ng-class="{ sortorder: $ctrl.predicate == 'description', reverse: $ctrl.reverse }">Type</th>
          <th>Dato</th>
          <th>Forfallsdato</th>
          <th ng-click="$ctrl.order('customerNumber')" ng-class="{ sortorder: $ctrl.predicate == 'customerNumber', reverse: $ctrl.reverse }">Kundenummer</th>
          <th ng-click="$ctrl.order('recipientName')" ng-class="{ sortorder: $ctrl.predicate == 'recipientName', reverse: $ctrl.reverse }">Mottager</th>
          <th ng-click="$ctrl.order('orderNumber')" ng-class="{ sortorder: $ctrl.predicate == 'orderNumber', reverse: $ctrl.reverse }">Ordre referanse</th>
          <th>MVA</th>
          <th>Bel&oslash;p</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.documents | orderBy:$ctrl.predicate:$ctrl.reverse track by $index">
        <td ng-show="$ctrl.state === 'draft'">
          <input type="checkbox" ng-checked="$ctrl.isSelected(item.number)" ng-click="$ctrl.selectHandler(item.number)">
        </td>

        <td> <i ng-show="item.international" class="icon icon-flag-en left"></i></td>
          <td>
            <!-- Domestic -->
            <a ng-if="item.description === 'Faktura' && !item.isDraft" href="#/regning/{{ item.number }}">{{ item.number }}</a>
            <a ng-if="item.description === 'Faktura' && item.isDraft && item._links.self.uri.indexOf('international=true') === -1 && item.giroLayout" href="#/regning/kladd/{{ item.number }}">Kladd</a>
            <a ng-if="item.description === 'Faktura' && item.isDraft && item._links.self.uri.indexOf('international=true') === -1 && !item.giroLayout" href="#/regning/kladd/utengiro/{{ item.number }}">Kladd</a>

            <a ng-if="item.description === 'Kreditnota' && !item.isDraft" href="#/kreditnota/{{ item.number }}">{{ item.number }}</a>
            <a ng-if="item.description === 'Kreditnota' && item.isDraft && item._links.self.uri.indexOf('international=true') === -1 && item.giroLayout" href="#/kreditnota/kladd/{{ item.number }}">Kladd</a>
            <a ng-if="item.description === 'Kreditnota' && item.isDraft && item._links.self.uri.indexOf('international=true') === -1 && !item.giroLayout" href="#/kreditnota/kladd/utengiro/{{ item.number }}">Kladd</a>

            <!-- International -->
            <a ng-if="item.description === 'Faktura' && item.isDraft && item._links.self.uri.indexOf('international=true') !== -1" href="#/regning/kladd/engelsk/{{ item.number }}">Kladd</a>
            <a ng-if="item.description === 'Kreditnota' && item.isDraft && item._links.self.uri.indexOf('international=true') !== -1" href="#/kreditnota/kladd/engelsk/{{ item.number }}">Kladd</a>
          </td>
          <td>{{ item.description }}</td>
          <td>{{ item.date | dateFormat }}</td>
          <td>{{ item.dueDate | dateFormat }}</td>
          <td>{{ item.customerNumber }}</td>
          <td><a href="#/kunde/{{ item._links.recipient.uri | urlParser:1 }}">{{ item.recipientName }}</a></td>
          <td>{{ item.orderNumber }}</td>
          <td class="nowrap right-align">{{ item.tax | crowns }}</td>
          <td class="nowrap right-align">{{ item.total | crowns }}</td>
        </tr>
      </tbody>
      <tfoot ng-show="$ctrl.state">
        <tr>
          <th colspan=1" ng-show="$ctrl.state === 'draft'"></th>
          <th colspan=8"></th>
          <th class="nowrap right-align">{{ $ctrl.taxTotal | crowns }}</th>
          <th class="nowrap right-align">{{ $ctrl.total | crowns }}</th>
        </tr>
      </tfoot>
    </table>

    <button ng-show="$ctrl.documents && $ctrl.documents.length > 0  && $ctrl.state === 'draft'" type="submit" class="button" ng-click="$ctrl.deleteDrafts()" ng-disabled="$ctrl.loading || !$ctrl.selectedInvoiceNos.length">Slett {{$ctrl.selectedInvoiceNos.length}} kladd(er)</button>
  `
};

angular
  .module('SendRegning')
  .component('overviewList', overviewList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/oversikt/:year', {
        title: 'Oversikt',
        template: '<overview-list />',
        secure: true
      });
  });
